import { IFaq } from './Faq';

import { richTextWithPlaceholder } from 'utils/prismic';

export const useFaqData = ({ faq }: IFaq['data']) => {
  const questions =
    faq?.reduce((acm, { question, answer }) => {
      if (!question) return acm;

      return [
        ...acm,
        {
          question,
          answer: richTextWithPlaceholder(answer, ''),
        },
      ];
    }, []) ?? [];

  return { questions };
};
